module.exports = __webpack_public_path__ + "i18n/en_cfa957dbccf56b2c769665e1372cb501.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/en.json
// module id = aY29
// module chunks = 151